import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

register.registerKnockoutBinding("greedyHeight", {
    init: function (element, valueAccessor) {
        const value = valueAccessor();

        const rootElement = $(element).parent().closest(".lc-greedy-height-root");

        function calcSize() {
            if ($(element).is(":hidden")) {
                return;
            }

            const contenders = rootElement.find(".lc-greedy-height-contender:visible");

            let usedHeight = 0;
            contenders.each(function (_index: any, contender: HTMLElement) {
                if ($(contender).closest(".lc-greedy-height-root")[0] === rootElement[0]) {
                    usedHeight += $(contender).outerHeight(true);
                }
            });

            let remainingHeight = rootElement.height() - usedHeight - 1;
            // The -1 is a quick and dirty workaround for rounding errors causing scroll.
            // jQuery is rounding the numbers. Could use something like getBoundingClientRect instead.

            const config = ko.unwrap(valueAccessor());

            if (config && config.minHeight) {
                remainingHeight = Math.max(remainingHeight, config.minHeight);
            }

            const outerDiff = $(element).outerHeight(true) - $(element).height();

            const harmonizedHeight = remainingHeight - outerDiff;

            $(element).height(harmonizedHeight);
        }

        function wrapper() {
            window.requestAnimationFrame(calcSize);
        }

        let subscription: KnockoutSubscription;

        if (ko.isObservable(value)) {
            subscription = value.subscribe(wrapper);
        }

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            if (subscription) {
                subscription.dispose();
            }
        });

        wrapper();
    }
});
